import React, { Component } from 'react';
import classNames from 'classnames';
import { withContext } from '../utils/StateProvider';
import { formatDuration } from '../utils/rng';
import { playSound } from '../utils/audio';

// Shown when a run ends: escaped with the last stairs, or wiped out.
class RunSummary extends Component {
  state = { name: (this.props.context.savedParty || {}).name || '', saved: false };

  componentDidMount() {
    const { runResult } = this.props.context;
    if (runResult && runResult.outcome === 'defeat') playSound('defeat');
  }

  // As with the gem menu: the summary outlives any one run, so the name is
  // filled in when the run ends rather than when the game started
  componentDidUpdate(previous) {
    const { runResult, savedParty } = this.props.context;
    if (runResult && !previous.context.runResult) {
      this.setState({ name: (savedParty || {}).name || '', saved: false });
    }
  }

  render() {
    const { runResult, replayRun, restartGame, returnToMenu } = this.props.context;
    if (!runResult) return null;

    const { outcome, seed, levels, level, elapsed, stats, gold, party } = runResult;
    const won = outcome === 'victory';
    const survivors = party.filter((c) => c.condition !== 'dead');
    const kills = Object.entries(stats.kills).sort((a, b) => b[1] - a[1]);

    return (
      <div id="runSummary" className={outcome}>
        <div className="summary-panel">
          <h1>{won ? 'YOU ESCAPE THE DUNGEON' : 'YOUR PARTY HAS FALLEN'}</h1>
          <div className="summary-time">{formatDuration(elapsed)}</div>
          <div className="summary-sub">
            {won ? `All ${levels} levels cleared` : `Lost on level ${level} of ${levels}`} · Seed {seed}
          </div>

          <div className="summary-stats">
            <div className="summary-stat"><span>{stats.monsters}</span>monsters slain</div>
            <div className="summary-stat"><span>{stats.gold}</span>gold found</div>
            <div className="summary-stat"><span>{stats.xp}</span>experience</div>
            <div className="summary-stat"><span>{stats.chests}</span>chests opened</div>
            <div className="summary-stat"><span>{stats.items}</span>items found</div>
            <div className="summary-stat"><span>{stats.itemValue}</span>worth of loot</div>
            <div className="summary-stat"><span>{survivors.length} / {party.length}</span>survivors</div>
            <div className="summary-stat"><span>{gold}</span>gold carried out</div>
          </div>

          {kills.length > 0 && (
            <div className="summary-kills">
              {kills.map(([name, count]) => <span key={name}>{count} × {name}</span>)}
            </div>
          )}

          <div className="summary-save">
            <span>Keep this party for another day</span>
            <input
              value={this.state.name}
              maxLength={24}
              placeholder="Party name"
              onChange={(e) => this.setState({ name: e.target.value, saved: false })}
            />
            <button
              className={classNames('menu-button', 'small', { disabled: !this.state.name.trim() })}
              onClick={() => {
                if (!this.state.name.trim()) return;
                if (this.props.context.saveParty(this.state.name)) this.setState({ saved: true });
              }}
            >
              {this.state.saved ? 'SAVED' : 'SAVE PARTY'}
            </button>
          </div>

          <div className="summary-buttons">
            <button className="menu-button" onClick={() => { playSound('click'); replayRun(); }}>REPLAY THIS SEED</button>
            <button className="menu-button" onClick={() => { playSound('click'); restartGame(); }}>NEW RUN</button>
            <button className="menu-button" onClick={() => { playSound('click'); returnToMenu(); }}>MENU</button>
          </div>
        </div>
      </div>
    );
  }
}

export default withContext(RunSummary);
